import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import { LicenseInfo } from '@mui/x-license';
import { BrowserRouter as Router } from 'react-router-dom';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import CssReset from './components/CssReset/CssReset.tsx';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

const PRELOAD_RELOAD_FLAG = 'vite-preload-reloaded';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (!sessionStorage.getItem(PRELOAD_RELOAD_FLAG)) {
    sessionStorage.setItem(PRELOAD_RELOAD_FLAG, 'true');
    window.location.reload();
  }
});

window.addEventListener('load', () => {
  sessionStorage.removeItem(PRELOAD_RELOAD_FLAG);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <CssReset />
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Router>
          <App />
        </Router>
      </LocalizationProvider>
    </ThemeProvider>
  </StrictMode>
);
